module.exports = __webpack_public_path__ + "img/Dental3d_2.513515c2.png";